var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_5193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8787 26.5321C55.8787 45.1045 31.9999 61.0237 31.9999 61.0237C31.9999 61.0237 8.12109 45.1045 8.12109 26.5321C8.12109 20.1991 10.6369 14.1254 15.115 9.64725C19.5932 5.16911 25.6668 2.65332 31.9999 2.65332C38.3329 2.65332 44.4066 5.16911 48.8847 9.64725C53.3629 14.1254 55.8787 20.1991 55.8787 26.5321Z",
    stroke: "#2C2C2C",
    strokeWidth: 5.3064,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 34.4915C36.3961 34.4915 39.9597 30.9278 39.9597 26.5319C39.9597 22.1359 36.3961 18.5723 32.0001 18.5723C27.6042 18.5723 24.0405 22.1359 24.0405 26.5319C24.0405 30.9278 27.6042 34.4915 32.0001 34.4915Z",
    stroke: "#2C2C2C",
    strokeWidth: 5.3064,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_5193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.6768,
    height: 63.6768,
    fill: "white",
    transform: "translate(0.161621)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.cc5ff288a71b5c2cef758fae021565e9.svg";
export { ForwardRef as ReactComponent };